import React from 'react'

import {
  Container,
  Item,
} from './styles'

export type NavItemProps = {
  label: string;
  onClick: () => void;
}

type Props = {
  items: NavItemProps[];
  selectedItemId: number;
}

const Navbar = ({
  items,
  selectedItemId,
}: Props) => (
  <Container>
    {
      items.map((item, index) => (
        <Item
          key={item.label}
          onClick={item.onClick}
          selected={index === selectedItemId}
        >
          {item.label}
        </Item>
      ))
    }
  </Container>
)

export default Navbar
